import React from 'react';
import { Grid, TextField, Button, DialogContent, MenuItem } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import DraggableDialog from '../../ui/draggableDialog';
import { ValidRoleService } from '../../../service/validDataService';
import { toast } from 'react-toastify';

export default function AddRoleForm({ open, onClose, onRecordAdded }) {
  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      const { code, message, data } = await ValidRoleService.add(values);
      setSubmitting(false);
      if (code === 0) {
        toast.success(message || 'Role created');
        resetForm();
        onClose();
        onRecordAdded(Array.isArray(data) ? data : [data]);
      } else {
        toast.error(message || 'Failed to create role');
      }
    } catch (e) {
      setSubmitting(false);
      toast.error('Failed to create role');
    }
  };

  return (
    <DraggableDialog title={'Add Role'} onClose={onClose} open={open} width={'sm'}>
      <DialogContent>
        <Formik initialValues={{ name: '', description: '', status: 'active' }} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Field as={TextField} name="name" label="Name" size="small" required fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Field as={TextField} name="description" label="Description" size="small" fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <Field as={TextField} name="status" label="Status" size="small" select fullWidth>
                    <MenuItem value={'active'}>Active</MenuItem>
                    <MenuItem value={'inactive'}>Inactive</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" disabled={isSubmitting}>Create</Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </DraggableDialog>
  );
}
